/* file description */
import { TreeSelect } from 'antd';
import React, { FC, useEffect } from 'react';
import { COLUMN_FROM } from '../../effects/consts';
import { useGetTreeData, useSetVal } from './effect';
import { MobileRecordTreeSelect } from './MobileRecordTreeSelect';
import { RecordTreeSelectProps } from './type';
import memo from '../memo';

export const RecordTreeSelect: FC<RecordTreeSelectProps> = ({
  API,
  field,
  value,
  onChange,
  form,
  config,
  disabled,
  columnFrom,
  storeValue,
  rowsData,
  isMobile,
  allowClear,
  moduleInfo,
}) => {
  const { treeData } = useGetTreeData({ field, API, form, config, columnFrom, storeValue, rowsData, moduleInfo });
  const { selectTree } = useSetVal({ onChange, field, form, config, columnFrom, treeData });
  // 编辑初始化时给联动展示字段赋值
  useEffect(() => {
    if (value) {
      const { showFields = [] } = field?.bizConfig || {};
      const selectData = treeData.find((item: any) => item.value === value);
      showFields.forEach((item: { key: any; realLabel: any }) => {
        const values: Record<any, any> = {};
        const setName = `${field.name}_LINK_${item?.key}`;
        if (columnFrom === COLUMN_FROM.FORM) {
          values[setName] = selectData?.[item?.key];
          form.setFieldsValue(values);
        }
        if (columnFrom === COLUMN_FROM.TABLE) {
          const tableKey = config.rowIndex;
          values[tableKey] = {};
          values[tableKey][setName] = selectData?.[item?.key];
          form.setFieldsValue(values);
        }
      });
    }
  }, [treeData]);

  if (isMobile) {
    return (
      <MobileRecordTreeSelect
        value={value}
        options={treeData}
        onChange={selectTree}
        disabled={disabled}
      />
    );
  }

  return (
    <>
      <TreeSelect
        treeDataSimpleMode
        style={{ width: '100%', minWidth: '100px' }}
        allowClear={allowClear !== false}
        showSearch
        treeNodeFilterProp="title"
        value={value}
        disabled={disabled}
        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
        treeData={treeData}
        onChange={selectTree}
      />
    </>
  );
};
export default memo(RecordTreeSelect);
